export function buildErrorMessage(errors) {
  let message = '';
  errors.forEach(data => {
    if (data.field) {
      message += `${data.field} `;
    }
    message += `${data.message}<br />`;
  });
  return message.replace(/<br[^>]*>?$/gi, '');
}

export function getErrorMessage(error) {
  if (error && error.errors && error.errors.length) {
    return buildErrorMessage(error.errors);
  }
  return 'Terjadi kesalahan pada sistem, silakan coba kembali';
}

export function getErrorNotification(error) {
  return {
    content: getErrorMessage(error),
    type: 'warning',
  };
}

export function getErrorNotificationBazaar(error) {
  return {
    text: getErrorMessage(error),
    type: 'error',
  };
}

export function isErrorOAuth(error = {}) {
  return getErrorMessage(error) === 'Invalid Oauth Token';
}

export default {
  getErrorMessage,
  getErrorNotification,
  getErrorNotificationBazaar,
};
